import { jsx as t, jsxs as r, Fragment as p } from "react/jsx-runtime";
import { getInitialsFromName as E } from "@one-snap/toolbox";
import { colors as f } from "@one-snap/sparkles-styles";
function x(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var C = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var a = {}.hasOwnProperty;
    function n() {
      for (var i = [], s = 0; s < arguments.length; s++) {
        var l = arguments[s];
        if (l) {
          var d = typeof l;
          if (d === "string" || d === "number")
            i.push(l);
          else if (Array.isArray(l)) {
            if (l.length) {
              var o = n.apply(null, l);
              o && i.push(o);
            }
          } else if (d === "object")
            if (l.toString === Object.prototype.toString)
              for (var h in l)
                a.call(l, h) && l[h] && i.push(h);
            else
              i.push(l.toString());
        }
      }
      return i.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(C);
var g = C.exports;
const c = /* @__PURE__ */ x(g), v = 24, S = (e = v) => ({ fontSize: `${e / 16}rem` }), m = ({ name: e, className: a, size: n, ariaLabel: i, ...s }) => {
  const l = `icon-${e.toLowerCase()}`, d = S(n), o = `icon ${a || ""} ${l}`;
  return /* @__PURE__ */ t(
    "i",
    {
      className: o,
      "aria-label": i ?? e,
      style: d,
      ...s
    }
  );
};
var y = /* @__PURE__ */ ((e) => (e.Account = "account", e.Add = "add", e.AlternateEmail = "alternate-email", e.ArrowLeft = "arrow-left", e.ArrowRight = "arrow-right", e.Call = "call", e.CheckCircle = "check-circle", e.Check = "check", e.ChevronDown = "chevron-down", e.ChevronLeft = "chevron-left", e.ChevronRight = "chevron-right", e.ChevronUp = "chevron-up", e.Close = "close", e.Dashboard = "dashboard", e.Description = "description", e.Email = "email", e.Error = "error", e.Facebook = "facebook", e.Filter = "filter", e.Home = "home", e.InfoFilled = "info-filled", e.Info = "info", e.Instagram = "instagram", e.Language = "language", e.List = "list", e.LocationArrow = "location-arrow", e.LocationOff = "location-off", e.LocationOn = "location-on", e.Location = "location", e.Lock = "lock", e.PaymentCard = "payment-card", e.Person = "person", e.PersonalCheck = "personal-check", e.Schedule = "schedule", e.Search = "search", e.Service = "service", e.Shipping = "shipping", e.SmsFailed = "sms-failed", e.StarFull = "star-full", e.StarHalf = "star-half", e.Twitter = "twitter", e.Url = "url", e.Warning = "warning", e.Youtube = "youtube", e))(y || {});
const w = {
  48: "14px",
  40: "14px",
  32: "14px",
  24: "10px",
  18: "8px"
};
function k(e) {
  const a = (e == null ? void 0 : e.size) || 40, n = {
    width: `${a}px`,
    height: `${a}px`,
    fontSize: w[a]
  };
  return e != null && e.url ? /* @__PURE__ */ t(
    "img",
    {
      className: c("rounded-full"),
      style: n,
      src: e.url,
      "data-testid": "avatar-image",
      alt: `${e.displayText} avatar`
    }
  ) : /* @__PURE__ */ t(
    "span",
    {
      className: c(
        "rounded-full",
        "flex",
        "justify-center",
        "snap-background-color-grey-300",
        "snap-color-dark-blue",
        "items-center",
        "secondaryHeavyFont"
      ),
      style: n,
      children: e.useIconFallback ? /* @__PURE__ */ t(
        m,
        {
          name: "person",
          "data-testid": "icon-person",
          className: c("text-SnapDarkBlue", {
            "text-[14px]": [40, 48, 32].includes(a),
            "text-[10px]": a === 24,
            "text-[8px]": a === 18
          })
        }
      ) : E((e == null ? void 0 : e.displayText) || "")
    }
  );
}
function B({ url: e, label: a, icon: n, active: i }) {
  return /* @__PURE__ */ r(p, { children: [
    e ? /* @__PURE__ */ t(
      "a",
      {
        className: c(
          "not-italic font-bold text-[10px] leading-[14px] tracking-[0.04em] uppercase  hover:text-SnapMediumBlue  visited:text-SnapDarkBlue",
          i || n ? "text-SnapBlue underline" : "text-SnapGrey400"
        ),
        href: e,
        children: a
      }
    ) : /* @__PURE__ */ t(
      "span",
      {
        className: c(
          "not-italic font-bold text-[10px] leading-[14px] tracking-[0.04em] uppercase  hover:text-SnapMediumBlue  visited:text-SnapDarkBlue",
          i || n ? "text-SnapBlue underline" : "text-SnapGrey400"
        ),
        children: a
      }
    ),
    n && /* @__PURE__ */ t(
      "span",
      {
        className: c(
          "[&>svg]:w-[14px] [&>svg]:my-0 [&>svg]:mx-[10px] [&>svg]:text-SnapGrey400"
        ),
        children: /* @__PURE__ */ t(m, { name: "chevron-right", className: "text-[10px] mx-3" })
      }
    )
  ] });
}
function F({
  arcColor: e = f.SnapWhite,
  borderColor: a = f.SnapWhite,
  className: n
}) {
  return /* @__PURE__ */ r("svg", { className: c("spinnerRing", n), viewBox: "0 0 50 50", children: [
    /* @__PURE__ */ t(
      "circle",
      {
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        strokeWidth: "5",
        stroke: a,
        className: "opacity-[0.16]"
      }
    ),
    /* @__PURE__ */ t(
      "circle",
      {
        className: "spinnerRingArc",
        cx: "25",
        cy: "25",
        r: "20",
        fill: "none",
        strokeWidth: "5",
        stroke: e
      }
    )
  ] });
}
const u = (e) => e.condition ? /* @__PURE__ */ t(p, { children: e.children }) : null;
function N({ animationDuration: e = 1 }) {
  return /* @__PURE__ */ r(
    "svg",
    {
      className: "place-self-center",
      width: 106.75,
      height: 106.56,
      viewBox: "0 0 90 122",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ r("g", { clipPath: "url(#clip0_6300_123849)", children: [
          /* @__PURE__ */ t(
            "path",
            {
              d: "M40.5075 98.928C35.9881 96.8644 32.4212 94.0631 29.788 90.5056C27.1549 86.9573 25.7543 82.9889 25.5768 78.6003H41.0957C41.3572 81.6723 42.8232 84.2401 45.503 86.2944C48.1735 88.3579 51.535 89.3851 55.5688 89.3851C59.6026 89.3851 63.0388 88.5727 65.3638 86.948C67.6888 85.3233 68.8467 83.241 68.8467 80.7012C68.8467 77.984 67.5488 75.9671 64.9623 74.6505C62.3758 73.334 58.2767 71.8867 52.6648 70.3086C47.2304 68.8146 42.8045 67.3673 39.3776 65.9667C35.9601 64.5661 33.0001 62.4185 30.4977 59.5238C27.9952 56.6292 26.7534 52.8195 26.7534 48.0854C26.7534 44.2291 27.8925 40.6995 30.1709 37.4967C32.4492 34.294 35.7173 31.7729 39.9659 29.9334C44.2144 28.0939 49.1073 27.1695 54.635 27.1695C62.88 27.1695 69.519 29.2518 74.5612 33.4163C79.6034 37.5808 82.302 43.258 82.6475 50.4478H67.6515C67.39 47.2077 66.0735 44.6212 63.7017 42.6884C61.33 40.7649 58.1366 39.7938 54.1028 39.7938C50.069 39.7938 47.1277 40.5408 45.0268 42.0254C42.9259 43.5194 41.8707 45.4896 41.8707 47.9454C41.8707 49.8782 42.571 51.4936 43.9717 52.8102C45.3723 54.1268 47.081 55.1539 49.0979 55.9009C51.1148 56.6479 54.0935 57.591 58.0432 58.7302C63.3002 60.1308 67.6235 61.5594 71.0036 63.0067C74.3745 64.454 77.2971 66.583 79.7528 69.3842C82.2086 72.1948 83.4785 75.9204 83.5625 80.5612C83.5625 84.6883 82.4234 88.3673 80.145 91.6074C77.8667 94.8475 74.6453 97.3966 70.4807 99.2361C66.3162 101.076 61.4234 102 55.8116 102C50.1998 102 45.0081 100.973 40.4888 98.9093L40.5075 98.928Z",
              fill: "#062D4E"
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M9.37633 54.3603C7.78896 54.2856 6.29496 53.3331 5.60399 51.7738C4.62356 49.5701 5.61333 47.0023 7.81697 46.0219L13.5315 43.4821C15.7351 42.511 18.3029 43.4914 19.2834 45.6951C20.2638 47.8987 19.274 50.4665 17.0704 51.447L11.3559 53.9868C10.7116 54.2762 10.0393 54.3883 9.37633 54.3603Z",
              fill: "#E6E6E6",
              children: /* @__PURE__ */ t(
                "animate",
                {
                  attributeName: "fill",
                  values: "#E6E6E6;#062D4E;#062D4E;#062D4E;#062D4E",
                  dur: `${e}s`,
                  repeatCount: "indefinite"
                }
              )
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M18.471 37.7116C18.0042 37.6929 17.5279 37.5902 17.0611 37.4035L2.73739 31.6609C0.505731 30.7645 -0.577415 28.2247 0.309645 25.9931C1.20604 23.7614 3.7365 22.6783 5.97749 23.5653L20.3012 29.3079C22.5328 30.2043 23.616 32.7441 22.7289 34.9757C22.0193 36.7498 20.2732 37.7956 18.471 37.7116Z",
              fill: "#E6E6E6",
              children: /* @__PURE__ */ t(
                "animate",
                {
                  attributeName: "fill",
                  values: "#E6E6E6;#E6E6E6;#3D5CCF;#3D5CCF;#3D5CCF",
                  dur: `${e}s`,
                  repeatCount: "indefinite"
                }
              )
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M27.7992 27.0575C30.4602 27.0575 32.6173 24.9003 32.6173 22.2393C32.6173 19.5784 30.4602 17.4212 27.7992 17.4212C25.1382 17.4212 22.981 19.5784 22.981 22.2393C22.981 24.9003 25.1382 27.0575 27.7992 27.0575Z",
              fill: "#E6E6E6",
              children: /* @__PURE__ */ t(
                "animate",
                {
                  attributeName: "fill",
                  values: "#E6E6E6;#E6E6E6;#E6E6E6;#1B844A;#1B844A",
                  dur: `${e}s`,
                  repeatCount: "indefinite"
                }
              )
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M19.5448 15.9833C18.2469 15.9179 16.9957 15.283 16.1926 14.1345L11.0757 6.86056C9.69376 4.89035 10.1606 2.17315 12.1308 0.791204C14.101 -0.590741 16.8182 -0.11453 18.2002 1.84634L23.3171 9.12023C24.6991 11.0904 24.2322 13.8076 22.262 15.1896C21.4403 15.7685 20.4785 16.0206 19.5448 15.9739V15.9833Z",
              fill: "#E6E6E6",
              children: /* @__PURE__ */ t(
                "animate",
                {
                  attributeName: "fill",
                  values: "#E6E6E6;#E6E6E6;#E6E6E6;#1B844A;#1B844A",
                  dur: `${e}s`,
                  repeatCount: "indefinite"
                }
              )
            }
          ),
          /* @__PURE__ */ t(
            "path",
            {
              d: "M41.8707 21.5578C41.6746 21.5484 41.4879 21.5297 41.2918 21.4924C38.9294 21.0535 37.3607 18.7845 37.7902 16.4222L40.0126 4.30211C40.4421 1.93039 42.7204 0.371035 45.0828 0.800559C47.4452 1.23942 49.0139 3.50843 48.5844 5.87081L46.362 17.9908C45.9605 20.1665 44.0183 21.6605 41.8707 21.5578Z",
              fill: "#E6E6E6",
              children: /* @__PURE__ */ t(
                "animate",
                {
                  attributeName: "fill",
                  values: "#E6E6E6;#E6E6E6;#E6E6E6;#E6E6E6;#FFCA4D",
                  dur: `${e}s`,
                  repeatCount: "indefinite"
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "clip0_6300_123849", children: /* @__PURE__ */ t("rect", { width: "83.5625", height: "102", fill: "white" }) }) })
      ]
    }
  );
}
function D({
  className: e,
  title: a,
  description: n,
  animationDuration: i
}) {
  return /* @__PURE__ */ r(
    "div",
    {
      "data-testid": "app-spinner",
      className: c(
        "AppSpinner fixed w-full self-center justify-center h-full bg-white z-50 top-0 left-0 flex flex-col p-4",
        e
      ),
      children: [
        /* @__PURE__ */ t(N, { animationDuration: i }),
        /* @__PURE__ */ r("div", { className: "text-center flex flex-col", children: [
          /* @__PURE__ */ t(u, { condition: a, children: /* @__PURE__ */ t("span", { className: "text-[20px] text-SnapDarkBlue font-semibold", children: a }) }),
          /* @__PURE__ */ t(u, { condition: n, children: /* @__PURE__ */ t("span", { className: "secondaryFont", children: n }) })
        ] })
      ]
    }
  );
}
function $({
  children: e,
  className: a,
  as: n = "h2",
  size: i = "xl",
  heavy: s = !0,
  ...l
}) {
  return /* @__PURE__ */ t(
    n,
    {
      className: c(
        "heading",
        {
          displayFont: i === "displayFont",
          headingXL: i === "xl",
          headingL: i === "l",
          headingMHeavy: i === "m",
          headingSHeavy: i === "s",
          "font-normal": !s
        },
        a
      ),
      ...l,
      children: e
    }
  );
}
const H = ({
  enable: e = !1,
  environment: a,
  buildBranch: n,
  additionalInfo: i,
  className: s
}) => /* @__PURE__ */ t(u, { condition: e, children: /* @__PURE__ */ t("div", { className: s, children: a && /* @__PURE__ */ r("div", { className: "w-full bg-SnapBlue text-SnapGrey300 py-2 px-3 text-xs text-center", children: [
  /* @__PURE__ */ t("span", { className: "font-bold", children: "Debug Info (Displayed Only in Lower Environments):" }),
  /* @__PURE__ */ r("span", { children: [
    " Current Environment: ",
    a
  ] }),
  /* @__PURE__ */ r("span", { children: [
    ", Build Branch: ",
    n
  ] }),
  /* @__PURE__ */ r("span", { children: [
    ", Additional Info: ",
    i
  ] })
] }) }) });
export {
  k as A,
  B,
  $ as H,
  m as I,
  u as R,
  F as S,
  H as V,
  y as a,
  D as b,
  c,
  x as g
};
